import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortable } from '@angular/material/sort';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Companie } from 'src/app/core/models/companie.model';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { CompanieService } from 'src/app/core/services/companie.service';
import { SwalService } from 'src/app/shared/services/swal.service';

interface ApiResponse {
  error: boolean;
  message: string;
}

@Component({
  selector: 'app-companie-start',
  templateUrl: './companie-start.component.html',
  styleUrls: ['./companie-start.component.css']
})
export class CompanieStartComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('versionRef', { read: ElementRef }) versionRef: ElementRef<HTMLInputElement>;
  @ViewChild('licenceRef', { read: ElementRef }) licenceRef: ElementRef<HTMLInputElement>;
  @ViewChild('companyNameRef', { read: ElementRef }) companyNameRef: ElementRef<HTMLInputElement>;
  @ViewChild('companySituationRef', { read: ElementRef }) companySituationRef: ElementRef<HTMLSelectElement>;
  version: string;
  dataSource: MatTableDataSource<Companie>;
  licenceDate: string;
  companyName: string;
  loaderConfig: any;
  companiesApi: Companie[] = [];
  displayedColumns = ['Name', 'Admin', 'E-mail', 'ApiToken', 'licenceDate', 'motelVersion', 'LastCheck', 'statusDatabase', 'Situation', 'Options'];

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private companieService: CompanieService,
    private ngxLoaderService: NgxUiLoaderService,
    private swalService: SwalService
  ) { }

  ngOnInit() {
    this.loaderConfig = this.loaderService.getDefaultLoaderConfig();
    this.getCompanies();
  }

  /**
   * Traz todas as Empresas
   */
  async getCompanies() {
    try {
      this.ngxLoaderService.start();
      const response = await this.companieService.getAllCompaniesInfo();
      this.companiesApi = response;
      this.setTableData(this.companiesApi);
      this.ngxLoaderService.stop();
    } catch (error) {
      this.ngxLoaderService.stop();
      this.swalService.fireErrorSwal('Erro ao carregar empresas. Por favor, tente novamente.');
    }
  }

  /**
   * Preenche a tabela com as Empresas trazidas pela API
   *
   * @param {Object[]} tableData
   */
  setTableData(tableData: Companie[]) {
    const data = tableData.map(companie => {
      return {
        ...companie,
        licenceDate: this.dateFormat(companie.licenceDate)
      };
    });

    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;

    this.sort.sort(({id: 'name', start: 'asc'}) as MatSortable);
    this.dataSource.sort = this.sort;

    this.setFilterPredicate();
    this.verifyIfFilterAlreadyExists();
  }

  /**
   * Atualiza os dados da tabela
   *
   * @param tableDataInfoNew
   */
  async updateTableData() {
    try {
      const responseNew = await this.companieService.getAllCompaniesInfo();
      const dataNew = responseNew.map(companie => ({
        ...companie,
        licenceDate: this.dateFormat(companie.licenceDate)
      }));
      
      if (this.dataSource) {
        this.dataSource.data = dataNew;
        this.dataSource.connect();
      }
    } catch (error) {
      this.swalService.fireErrorSwal('Erro ao atualizar dados. Por favor, tente novamente.');
    }
  }

  async verifyIfFilterAlreadyExists() {
    const filter = JSON.parse(localStorage.getItem('companyFilter'));

    if (filter !== null) {
      localStorage.removeItem('companyFilter');

      const version = filter.filter(item => item.id === 'motelVersion')[0];
      const filterName = filter.filter(item => item.id === 'name')[0];
      const licenceDate = filter.filter(item => item.id === 'licenceDate')[0];
      const filterSituation = filter.filter(item => item.id === 'isActive')[0];

      if (version) {
        this.versionRef.nativeElement.value = version.value;
        this.versionRef.nativeElement.focus();
      }

      if (licenceDate) {
        this.licenceRef.nativeElement.value = licenceDate.value;
        this.licenceRef.nativeElement.focus();
      }

      if (filterName) {
        this.companyNameRef.nativeElement.value = filterName.value;
        this.companyNameRef.nativeElement.focus();
      }

      if (filterSituation) {
        this.companySituationRef.nativeElement.value = filterSituation.value;
        this.companySituationRef.nativeElement.focus();
      }
    }

  }

  setFilterPredicate() {
    this.dataSource.filterPredicate =
    (data: any, filtersJson) => {
      const matchFilter = [];

      const filters = JSON.parse(filtersJson);

      filters.map(filter => {
        const val = data[filter.id] === null ? '' : data[filter.id];

        if (filter.id === 'isActive') {
          let finalValue = (val === (filter.value === 'true'));

          if (filter.value === '') {
            finalValue = true;
          }

          matchFilter.push(finalValue);
        } else {
          matchFilter.push(
            val.toLowerCase().includes(filter.value.toLowerCase())
          );
        }

      });

      return matchFilter.every(Boolean);
    };
  }

  /**
   * Filtra a tabela de Empresas
   *
   * @param string value
   */
  filterSituationTable(value: string) {
    const tableFilters = [];

    if (this.dataSource.filter.length > 0) {
      const actualFilter: any[] = JSON.parse(this.dataSource.filter);

      actualFilter.map(filter => {
        if (filter.id === 'name') tableFilters.push(filter);

        if (filter.id === 'motelVersion') tableFilters.push(filter);

        if (filter.id === 'licenceDate') tableFilters.push(filter);
      });
    }

    tableFilters.push({
      id: 'isActive',
      value: value
    });

    this.dataSource.filter = JSON.stringify(tableFilters);

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /**
   * Filtra a tabela de Empresas
   *
   * @param string value
   */
  filterTable(value: string, id: string) {
    const tableFilters = [];

    if (this.dataSource.filter.length !== 0) {
      const actualFilter: any[] = JSON.parse(this.dataSource.filter);

      actualFilter.map(filter => {
        if (filter.id === 'isActive') tableFilters.push(filter);

        if(id !== 'name' && filter.id === 'name') tableFilters.push(filter);

        if(id !== 'licenceDate' && filter.id === 'licenceDate') tableFilters.push(filter);

        if(id !== 'motelVersion' && filter.id === 'motelVersion') tableFilters.push(filter);
      });
    }

    if (id === 'name') tableFilters.push({ id: 'name', value: value });

    if (id === 'motelVersion') tableFilters.push({ id: 'motelVersion', value: value });

    if (id === 'licenceDate') tableFilters.push({ id: 'licenceDate', value: value });

    this.dataSource.filter = JSON.stringify(tableFilters);

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /**
   * Navega para os detalhes da Empresa selecionada
   *
   * @param string id
   */
  onOptionsClicked(id: string) {
    this.saveFilter();

    const companie = this.companiesApi.filter(companie => companie.id === id);
    this.router.navigate(
      [`company/detail/${companie[0].id}`],
      { state: {companie: companie[0] } }
    );
  }

  saveFilter() {
    if (this.dataSource.filter.length > 0) {
      localStorage.setItem('companyFilter', this.dataSource.filter);
    }
  }

  /**
   * Navega para ver as informações de configuração
   * do InfoMotel da Empresa
   *
   * @param string id
   */
  onInfoOptionClicked(id: string) {
    this.saveFilter();

    const companie = this.companiesApi.filter(companie => companie.id === id);
    this.router.navigate(
      [`company/info/${companie[0].id}`],
      { state: {companie: companie[0] } }
    );
  }

  async onDeleteOptionClicked(id: string) {
    const confirmModal = await this.swalService.fireConfirmSwal();

    if (confirmModal.value) {
      try {
        this.ngxLoaderService.start();
        const response = await this.companieService.deleteCompany(id) as ApiResponse;

        if (response) {
          if (!response.error) {
            await this.getCompanies();
            this.swalService.fireSuccessSwal(response.message);
          } else {
            this.swalService.fireErrorSwal(response.message);
          }
        }
      } catch (error) {
        this.swalService.fireErrorSwal('Erro ao deletar empresa. Por favor, tente novamente.');
      } finally {
        this.ngxLoaderService.stop();
      }
    }
  }

  /**
   * Traz uma string formatada da data sendo usada
   *
   * @param {string} value
   * @param {boolean=} justDate
   */
  dateFormat(value: string, justDate?: boolean): string {
    if (!value) return null;

    let string = value.replace(/-/g, '/').replace(/T/g, ' ').substr(0, 19);

    if (justDate) {
      string = value.replace(/-/g, '/').replace(/T/g, ' ').substr(0, 10);

      return formatDate(string, 'dd/MM/yyyy', 'pt');
    }

    return formatDate(string, 'dd/MM/yyyy HH:mm:ss', 'pt', '-0600');
  }

}
